import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';
import { useSignOutStaff, useStaffSession } from '@/auth/react';
import { env } from '@/lib/env';
import { ManagerHomeLink } from './nav';

/**
 * The dark header of every operations surface (kitchen, counter, waiter, admin): the product mark, the
 * surface's name, the environment, who is signed in, and sign out. A branch manager also gets the way back
 * to the dashboard. `title` is a plain text node so a screen can be told apart by its header.
 */
export function StaffHeader({ title }: { title: string }) {
  const session = useStaffSession();
  const signOut = useSignOutStaff();
  return (
    <header className="bg-primary-deep text-white">
      <div className="flex min-h-14 items-center justify-between gap-3 px-4 md:px-6">
        <span className="flex min-w-0 items-center gap-2">
          <ManagerHomeLink tone="light" />
          <span className="flex min-w-0 items-baseline gap-2">
            <span className="text-xs font-semibold tracking-wide text-white/70 uppercase">
              ServeFlow
            </span>
            <p className="truncate text-base font-bold">{title}</p>
          </span>
        </span>
        <span className="flex shrink-0 items-center gap-2">
          {env.appEnv !== 'production' && (
            <span className="hidden rounded-full bg-white/15 px-2 py-0.5 text-xs font-semibold sm:inline">
              {env.appEnv}
            </span>
          )}
          <span className="hidden max-w-40 truncate text-sm text-white/80 sm:inline">
            {session?.user.displayName}
          </span>
          <Button variant="onDark" onClick={signOut}>
            <Icon name="signOut" size={18} />
            Sign out
          </Button>
        </span>
      </div>
    </header>
  );
}
